import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { AuditRecordModel, PagingResultModelOfAuditRecordModel } from '../../gql-types.generated';

interface SliceState {
    auditRecordList?: AuditRecordModel[];
    error?: Error;
    requestsInFlight: number;
    auditRecordById?: AuditRecordModel;
    auditRecordsPagingResult?: PagingResultModelOfAuditRecordModel;
}

const initialState: SliceState = {
    auditRecordList: undefined,
    error: undefined,
    requestsInFlight: 0,
    auditRecordById: undefined,
    auditRecordsPagingResult: undefined
};

export const slice = createSlice({
    name: 'auditRecords',
    initialState,
    reducers: {
        fetchError: (state, action: PayloadAction<Error>) => {
            // eslint-disable-next-line no-param-reassign
            state.error = action.payload;
        },
        clearError: (state) => {
            // eslint-disable-next-line no-param-reassign
            state.error = undefined;
        },
        clearState: (state) => {
            // eslint-disable-next-line no-param-reassign
            state.auditRecordList = undefined;
            // eslint-disable-next-line no-param-reassign
            state.error = undefined;
            // eslint-disable-next-line no-param-reassign
            state.requestsInFlight = 0;
            // eslint-disable-next-line no-param-reassign
            state.auditRecordsPagingResult = undefined;
            // eslint-disable-next-line no-param-reassign
            state.auditRecordById = undefined;
        },
        fetchAuditRecordListSuccess: (state, action: PayloadAction<PagingResultModelOfAuditRecordModel>) => {
            // eslint-disable-next-line no-param-reassign
            state.auditRecordsPagingResult = action.payload;
            let records = state.auditRecordList;
            if (!records || !state.auditRecordsPagingResult.cursor?.previousPage) {
                records = [];
            }
            if (action.payload.nodes) {
                action.payload.nodes.map(node => {
                    if (!records?.some(i => i.id === node?.id)) {
                        records?.push(node as AuditRecordModel)
                    }
                    return node;
                });
            }
            // eslint-disable-next-line no-param-reassign
            state.auditRecordList = records;
        },
        incrementRequestsInFlight: state => {
            // eslint-disable-next-line no-param-reassign
            state.requestsInFlight += 1;
        },
        decrementRequestsInFlight: state => {
            // eslint-disable-next-line no-param-reassign
            if (state.requestsInFlight > 0) state.requestsInFlight -= 1;
        },
        fetchAuditRecordByIdSuccess: (state, action: PayloadAction<AuditRecordModel>) => {
            // eslint-disable-next-line no-param-reassign
            state.auditRecordById = action.payload;
        }
    }
});

export const selectAuditRecordList = (state: RootState): AuditRecordModel[] | undefined => state.auditRecords.auditRecordList;
export const selectAuditRecordById = (state: RootState): AuditRecordModel | undefined => state.auditRecords.auditRecordById;
export const selectError = (state: RootState): Error | undefined => state.auditRecords.error;
export const selectRequestsInFlight = (state: RootState): number => state.auditRecords.requestsInFlight;
export const selectAuditRecordsPagingResult = (state: RootState): PagingResultModelOfAuditRecordModel | undefined => state.auditRecords.auditRecordsPagingResult;

export const {
    clearState,
    clearError,
    fetchAuditRecordListSuccess,
    fetchAuditRecordByIdSuccess,
    incrementRequestsInFlight,
    decrementRequestsInFlight,
    fetchError
} = slice.actions;

export default slice.reducer;
